module.exports = __webpack_public_path__ + "img/mountains.37ea9514.svg";